import React, {useEffect, useRef} from 'react';
import style from './style.module.scss';
import {RegularModal} from 'modules/modals/components/RegularModal';
import {Typography} from 'components/Typography';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {sanitize} from 'isomorphic-dompurify';
import {useLoyaltyRestrictionInformerGtag} from 'modules/product-card/analytics/gtag/hooks/useLoyaltyRestrictionInformerGtag';

export const LoyaltyRestrictionPopup = () => {
    const productData = useAppSelector(selectProductData);
    const isSent = useRef(false);

    const {handleLoyaltyRestrictionPopupShow} = useLoyaltyRestrictionInformerGtag({
        product: productData ? {id: productData.id, title: productData.title, price: productData.price} : null,
    });

    useEffect(() => {
        if (isSent.current) {
            return;
        }

        handleLoyaltyRestrictionPopupShow();
        isSent.current = true;
    }, [handleLoyaltyRestrictionPopupShow]);

    const heading = productData?.price?.loyaltyRestrictionHint?.heading;
    const text = productData?.price?.loyaltyRestrictionHint?.text;

    const title = heading ? sanitize(heading) : null;
    const subtitle = text ? sanitize(text) : null;

    if (!title || !subtitle) {
        return null;
    }

    return (
        <RegularModal hasClose={true} className={style.main} isMobileBottomAlign={true} title={title}>
            <Typography variant={'body-16-r'} dangerouslySetInnerHTML={{__html: subtitle}} />
        </RegularModal>
    );
};
